<template>
  <div style="clear:both;">
    <v-card :color="backgroundColor">
      <v-toolbar v-if="!readonly" elevation="1" density="compact" :color="backgroundColor">
        <v-toolbar-title>{{ $t('Owner_Actions') }}</v-toolbar-title>
      </v-toolbar>
      <v-form ref="ownerForm" :model-value="valid" autocomplete="off">
        <template v-if="isAvailableForDecision || (isBeingRevised && !readonly)">
          <void :moc="moc" role="owner"></void>
          <v-dialog v-model="revisionReasonDialog" v-if="canMakeRevision" persistent max-width="600px">
            <template v-slot:activator="{ props: activatorProps }">
              <v-btn dark v-bind="activatorProps" color="accent" class="ma-2" v-if="!isBeingRevised && !ownerApproved">
                <span style="color: white !important;">{{ $t('Make_Revisions') }}</span></v-btn>
            </template>
            <v-card>
              <v-toolbar color="warning" dense><v-spacer></v-spacer><v-icon class="me-3" color="black">mdi-bell-alert-outline</v-icon></v-toolbar>
              <v-card-text class="text-h6 font-weight-bold">{{ $t('Revision_Reason') }}</v-card-text>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-form ref="revisionReasonMo" v-model="valid" autocomplete="off">
                        <v-textarea
                          v-model="revisionReason"
                          name="revisionReason"
                          variant="underlined"
                          :rules="revisionReasonRules"
                          auto-grow
                        ></v-textarea>
                      </v-form>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="card-button" color="primary" text @click="revisionReasonDialog = false">{{ $t('Cancel') }}</v-btn>
                <v-btn class="card-button" color="primary" text @click="makeRevisions()">{{ $t('Make_Revisions') }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-btn
            color="accent"
            v-if="!isMakePermanent"
            @click="saveOwnerFormChanges()"
            :disabled="moc.roles.coordinator == null"
            class="ma-2"
            > <span style="color: white !important;">{{ $t('Save') }}</span></v-btn>
            <v-btn
            @click="sendReminders()"
            :disabled="!enableReminderButton || totalNoResponseApprovals === 0"
            color="blue"
            class="ma-2 white--text"
          >
            {{ $t('Remind_Non_Responders') }}
          </v-btn>
          <template v-if="isBeingRevised && !readonly">
            <v-btn
              color="success"
              v-if="!isMakePermanent"
              @click="submitOwnerFormChanges()"
              :disabled="moc.roles.coordinator == null"
              class="ma-2"
              >{{ $t('Submit') }}</v-btn
            >
          </template>
        </template>

        <template v-if="isPendingOwnerDecision && !readonly">
          <template
            v-if="
              moc.changeType.type.key === 'permanent' ||
                (moc.changeType.type.key === 'temporary' &&
                  (!moc.flags.includes('extend') && !moc.flags.includes('makepermanent')))
            "
          >
            <void :moc="moc" role="owner"></void>
          </template>

          <!-- owner reject -->
          <v-dialog v-model="ownerRejectDialog" persistent max-width="600px">
            <template v-slot:activator="{ props: activatorProps }">
              <v-btn dark v-bind="activatorProps" color="error" class="ma-2">{{ $t('Reject') }}</v-btn>
            </template>
            <v-card>
              <v-toolbar color="warning" dense><v-spacer></v-spacer><v-icon class="me-3" color="black">mdi-bell-alert-outline</v-icon></v-toolbar>
              <v-card-text class="text-h6 font-weight-bold">{{ $t('Notification_RejectChange') }}</v-card-text>
              <v-card-text>
                <v-row>
                  <v-col cols="12">
                    <v-form ref="ownerRejectMo" v-model="ownerRejectReasonValid" autocomplete="off">
                      <v-textarea
                        :label="$t('Prompt_RejectComments')"
                        v-model="ownerRejectReason"
                        name="ownerRejectReason"
                        variant="underlined"
                        :rules="ownerRejectReasonRules"
                        auto-grow
                      ></v-textarea>
                    </v-form>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="card-button" text @click="ownerRejectDialog = false">{{ $t('Cancel') }}</v-btn>
                <!-- inner dialog -->
                <v-dialog v-model="ownerRejectConfirmationDialog" persistent max-width="600px">
                  <template v-slot:activator="{ props: activatorProps }">
                    <v-btn class="card-button" :disabled="!ownerRejectReasonValid" color="primary" text v-bind="activatorProps">{{ $t('Reject') }}</v-btn>
                  </template>
                  <v-card>
                    <v-toolbar color="warning" dense><v-spacer></v-spacer><v-icon class="me-3" color="black">mdi-bell-alert-outline</v-icon></v-toolbar>
                    <v-card-text class="text-h6 font-weight-bold">{{ $t('Reject_Confirmation') }}</v-card-text>
                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12">
                            {{ $t('Notification_RejectedChange') }}
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn class="card-button" text @click="ownerRejectDialog = false">{{ $t('Cancel') }}</v-btn>
                      <v-btn class="card-button" color="primary" text @click="submitOwnerReject()">{{ $t('OK') }}</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <!-- /inner dialog -->
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- /owner reject -->
          <!-- revisions needed -->
          <template
            v-if="
              moc.changeType.type.key === 'permanent' ||
                (moc.changeType.type.key === 'temporary' &&
                  (!moc.flags.includes('extend') && !moc.flags.includes('makepermanent')))
            "
          >
            <v-dialog v-model="ownerRevisionDialog" v-if="canMakeRevision" persistent max-width="600px">
              <template v-slot:activator="{ props: activatorProps }">
                <v-btn dark v-bind="activatorProps" color="accent" class="ma-2">
                  <span style="color: white !important;">{{$t('Revisions_Needed')}}</span>
                </v-btn>
              </template>
              <v-card>
                <v-toolbar color="warning" dense><v-spacer></v-spacer><v-icon class="me-3" color="black">mdi-bell-alert-outline</v-icon></v-toolbar>
                <v-card-text class="text-h6 font-weight-bold">{{ $t('Owner_Revisions_Needed') }}</v-card-text>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12">
                        <v-form ref="revisionReasonMo" v-model="ownerRevisionReasonValid" autocomplete="off">
                          <v-textarea
                            :label="$t('Prompt_CommentsToSupportDecision')"
                            v-model="revisionReason"
                            variant="underlined"
                            name="revisionReason"
                            :rules="ownerRevisionReasonRules"
                            auto-grow
                          ></v-textarea>
                        </v-form>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn class="card-button" text @click="ownerRevisionDialog = false">{{ $t('Cancel') }}</v-btn>
                  <!-- inner dialog -->
                  <v-dialog v-model="ownerRevisionConfirmationDialog" persistent max-width="600px">
                    <template v-slot:activator="{ props: activatorProps }">
                      <v-btn class="card-button" :disabled="!ownerRevisionReasonValid" color="primary" text v-bind="activatorProps">{{ $t('OK') }}</v-btn>
                    </template>
                    <v-card>
                      <v-toolbar color="warning" dense><v-spacer></v-spacer><v-icon class="me-3" color="black">mdi-bell-alert-outline</v-icon></v-toolbar>
                      <v-card-text class="text-h6 font-weight-bold">{{ $t('Revision_Confirmation') }}</v-card-text>
                      <v-card-text>
                        <v-container>
                          <v-row>
                            <v-col cols="12">{{ $t('Confirm_AreYouSure') }}</v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn class="card-button" text @click="ownerRevisionDialog = false">{{ $t('Cancel') }}</v-btn>
                        <v-btn class="card-button" color="primary" text @click="makeRevisions()">{{ $t('OK') }}</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <!-- /inner dialog -->
                </v-card-actions>
              </v-card>
            </v-dialog>
          </template>
          <!-- /revisions needed -->

          <!-- approve multipass -->
          <template v-if="moc.flags.includes('multipass') && moc.multiPassCurrentPass < moc.approvalProcessType.decisionPasses">
            <v-dialog v-model="ownerApprovalMultipassDialog" persistent max-width="600px">
              <template v-slot:activator="{ props: activatorProps }">
                <v-btn v-bind="activatorProps" color="success" :disabled="!canApprove" class="ma-2">{{ $t('Approve') }}</v-btn>
              </template>
              <v-card>
                <v-toolbar color="warning" dense><v-spacer></v-spacer><v-icon class="me-3" color="black">mdi-bell-alert-outline</v-icon></v-toolbar>
                <v-card-text class="text-h6 font-weight-bold">{{
                  $t('Notification_Owner_Approved_Multipass_Message')
                }}</v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn class="card-button" text @click="ownerApprovalMultipassDialog = false">{{ $t('Cancel') }}</v-btn>
                  <v-btn class="card-button" color="primary" text @click="submitOwnerApproval()" :loading="ownerApprovalLoading">{{
                    $t('OK')
                  }}</v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </template>
          <!-- /approve multipass -->
          <template v-else>
            <!-- approve -->
            <v-dialog v-model="ownerApprovalDialog" persistent max-width="600px">
              <template v-slot:activator="{ props: activatorProps }">
                <v-btn v-bind="activatorProps" color="success" :disabled="!canApprove" class="ma-2">{{ $t('Approve') }}</v-btn>
              </template>
              <v-card>
                <v-toolbar color="warning" dense>
                  <v-spacer></v-spacer>
                  <v-icon class="me-3" color="black">mdi-bell-alert</v-icon>
                </v-toolbar>
                <v-card-text class="text-h6 font-weight-bold">{{ $t('Notification_ApproveChange') }}</v-card-text>
                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col cols="12">
                        <v-form ref="ownerRevisionMo" v-model="ownerApprovalReasonValid" autocomplete="off">
                          <v-textarea
                            :label="$t('Comments')"
                            v-model="ownerApprovalReason"
                            variant="underlined"
                            name="ownerApprovalReason"
                            :placeholder="$t('No_Comment')"
                            auto-grow
                          ></v-textarea>
                        </v-form>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn
                    text
                    class="card-button"
                    @click="
                      ownerApprovalReason = null;
                      ownerApprovalDialog = false
                    "
                    >{{ $t('Cancel') }}</v-btn
                  >
                  <!-- inner dialog -->
                  <!-- // validUntil_Expired -->
                  <template v-if="isHoldValidUntilDateValid && moc.changeType.type.key === 'temporary' && !isMakePermanent && !isExtend">
                    <v-dialog v-model="ownerApprovalValidUntilExpiredDialog" persistent max-width="600px">
                      <template v-slot:activator="{ props: activatorProps }">
                        <v-btn class="card-button" :disabled="!canApprove" color="primary" text v-bind="activatorProps">{{ $t('Approve') }}</v-btn> </template
                      ><v-card>
                        <v-toolbar color="warning" dense><v-spacer></v-spacer><v-icon class="me-3" color="black">mdi-bell-alert-outline</v-icon></v-toolbar>

                        <v-card-text class="text-h6 font-weight-bold">{{ $t('ValidUntil_Date_Expired_Message') }} </v-card-text>
                        <v-card-text>
                          <v-container>
                            <v-row>
                              <v-col cols="12">
                                <v-menu
                                  v-model="formSettings.validUntilDateMenu1"
                                  :close-on-content-click="false"
                                  :nudge-right="40"
                                  transition="scale-transition"
                                  offset-y
                                  min-width="290px"
                                >
                                  <template v-slot:activator="{ props }">
                                    <v-text-field
                                      :model-value="$filters.DateFilter(moc.dates.validUntil)"
                                      :label="$t('Valid_Until_Date')"
                                      prepend-icon="mdi-calendar-outline"
                                      readonly
                                      variant="underlined"
                                      v-bind="props"
                                      name="validUntilDate"
                                      :error-messages="validUntilErrorMessage"
                                    ></v-text-field>
                                  </template>
                                  <v-date-picker
                                    :model-value="getDateObject(moc.dates.validUntil)"
                                    hide-header
                                    no-title
                                    :min="minTempValidUntilDate"
                                    :max="maxTempValidUntilDate"
                                    :readonly="readonly"
                                    v-on:update:model-value="formSettings.validUntilDateMenu1 = false; updateValue($event)"
                                  ></v-date-picker>
                                </v-menu>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <v-btn
                            text
                            class="card-button"
                            @click="
                              revertValidUntilDate();
                              ownerApprovalDialog = false
                            "
                            >{{ $t('Cancel') }}</v-btn
                          >
                          <!-- resume approval inside of validUntil_Expired -->
                          <v-dialog v-model="ownerApprovalConfirmationDialog" persistent max-width="600px">
                            <template v-slot:activator="{ props: activatorProps }">
                              <v-btn class="card-button" :disabled="isValidUntilDateValid" color="primary" text v-bind="activatorProps">{{ $t('Approve') }}</v-btn>
                            </template>
                            <v-card>
                              <v-toolbar color="warning" dense
                                ><v-spacer></v-spacer><v-icon class="me-3" color="black">mdi-bell-alert-outline</v-icon></v-toolbar
                              >

                              <v-card-text class="text-h6 font-weight-bold">{{ $t('Approval_Confirmation') }} </v-card-text>
                              <v-card-text>
                                <v-container>
                                  <v-row>
                                    <v-col cols="12">
                                      <template v-if="moc.changeType.type.key === 'permanent'">
                                        <div
                                          class="text-body-1"
                                          v-html="
                                            $t('Owner_Approval_Confirmation_Permanent', {
                                              coordinator: moc.roles.coordinator.displayName,
                                              startDate: formattedTempStartDate(),
                                              startDatePlus365: formattedTempStartDateBasedOnCommunitySetting()
                                            })
                                          "
                                        />
                                      </template>
                                      <template v-if="moc.changeType.type.key === 'temporary'">
                                        <template v-if="(moc.flags || []).includes('makepermanent')">
                                          {{ $t('Owner_Approval_Confirmation_Temporary_Make_Permanent') }}
                                        </template>
                                        <template v-else>
                                          <div
                                            class="text-body-1"
                                            v-html="
                                              $t('Owner_Approval_Confirmation_Temporary', {
                                                coordinator: moc.roles.coordinator.displayName,
                                                startDate: formattedTempStartDate(),
                                                validUntilDate: formattedValidUntilDate()
                                              })
                                            "
                                          />
                                        </template>
                                      </template>
                                    </v-col>
                                  </v-row>
                                </v-container>
                              </v-card-text>
                              <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn
                                  text
                                  class="card-button"
                                  @click="
                                    revertValidUntilDate();
                                    ownerApprovalDialog = false
                                  "
                                  >{{ $t('Cancel') }}</v-btn
                                >
                                <!-- whoa, what another inner-inner dialog, this is just crazy stuff here -->
                                <v-dialog v-model="ownerApprovalNotOkDialog" persistent max-width="600px">
                                  <template v-slot:activator="{ props: activatorProps }">
                                    <v-btn class="card-button" text v-bind="activatorProps" @click="temporarilySetApprovedStartDate()">{{ $t('Change') }}</v-btn>
                                  </template>
                                  <v-card>
                                    <v-toolbar color="warning" dense>
                                      <v-spacer></v-spacer>
                                      <v-icon class="me-3" color="black">mdi-bell-alert-outline</v-icon>
                                    </v-toolbar>
                                    <v-card-text class="text-h6 font-weight-bold">{{
                                      $t('Change_Start_Date_Coordinator')
                                    }}</v-card-text>
                                    <v-card-text>
                                      <v-container>
                                        <template v-if="moc.changeType.type.key === 'permanent'">
                                          <v-row>
                                            <v-col cols="12">
                                              <approved-start-date-field
                                                v-model="moc.dates.approvedStart"
                                                :model-value="startDate"
                                                :roles="roles"
                                                :moc="moc"
                                                :fromModal="true"
                                                @update:model-value="updateStartDate($event)"
                                              ></approved-start-date-field>
                                            </v-col>
                                          </v-row>
                                        </template>
                                        <!-- if temporary -->

                                        <template v-if="moc.changeType.type.key === 'temporary'">
                                          <v-row>
                                            <v-col cols="12">
                                              <v-menu
                                                v-model="formSettings.approvedStartDateMenu"
                                                :close-on-content-click="false"
                                                :nudge-right="40"
                                                transition="scale-transition"
                                                offset-y
                                                min-width="290px"
                                              >
                                                <template v-slot:activator="{ props }">
                                                  <v-text-field
                                                    :model-value="$filters.DateFilter(moc.dates.approvedStart)"
                                                    :label="$t('Owner_Approved_Start_Date')"
                                                    prepend-icon="mdi-calendar-outline"
                                                    readonly
                                                    variant="underlined"
                                                    v-bind="props"
                                                    name="approvedStartDate"
                                                    :error-messages="approvedStartErrorMessage"
                                                  ></v-text-field>
                                                </template>
                                                <v-date-picker
                                                  :model-value="getDateObject(moc.dates.approvedStart)"
                                                  @input="formSettings.approvedStartDateMenu = false"
                                                  no-title
                                                  hide-header
                                                  :min="minTempApprovedStartDate"
                                                  :max="maxTempApprovedStartDate"
                                                  :readonly="readonly"
                                                  v-on:update:model-value="formSettings.approvedStartDateMenu = false; updateStartDateValue($event)"
                                                ></v-date-picker>
                                              </v-menu>
                                            </v-col>
                                          </v-row>
                                          <v-row>
                                            <v-col cols="12">
                                              <v-menu
                                                v-model="formSettings.validUntilDateMenu2"
                                                :close-on-content-click="false"
                                                :nudge-right="40"
                                                transition="scale-transition"
                                                offset-y
                                                min-width="290px"
                                              >
                                                <template v-slot:activator="{ props }">
                                                  <v-text-field
                                                    :model-value="$filters.DateFilter(moc.dates.validUntil)"
                                                    :label="$t('Valid_Until_Date')"
                                                    prepend-icon="mdi-calendar-outline"
                                                    readonly
                                                    variant="underlined"
                                                    v-bind="props"
                                                    name="validUntilDate"
                                                    :error-messages="validUntilErrorMessage"
                                                  ></v-text-field>
                                                </template>
                                                <v-date-picker
                                                  :model-value="getDateObject(moc.dates.validUntil)"
                                                  hide-header
                                                  no-title
                                                  :min="minTempValidUntilDate"
                                                  :max="maxTempValidUntilDate"
                                                  :readonly="readonly"
                                                  v-on:update:model-value="formSettings.validUntilDateMenu2 = false; updateValue($event)"
                                                ></v-date-picker>
                                              </v-menu>
                                            </v-col>
                                          </v-row>
                                        </template>

                                        <v-row>
                                          <v-col cols="12">
                                            <people-picker
                                              v-model="moc.roles.coordinator"
                                              :user="moc.roles.coordinator"
                                              :label="$t('Select_Coordinator')"
                                              :readonly="readonly"
                                            ></people-picker>
                                          </v-col>
                                        </v-row>
                                      </v-container>
                                    </v-card-text>
                                    <v-card-actions>
                                      <v-spacer></v-spacer>
                                      <v-btn
                                        text
                                        class="card-button"
                                        @click="
                                          revertValidUntilDate();
                                          ownerApprovalNotOkDialog = false;
                                          resetApprovedStartDate()
                                        "
                                        >{{ $t('Cancel') }}</v-btn
                                      >
                                      <v-btn class="card-button" color="primary" text @click="ownerApprovalNotOkDialog = false">{{ $t('OK') }}</v-btn>
                                    </v-card-actions>
                                  </v-card>
                                </v-dialog>
                                <!-- /crazy stuff -->
                                <v-btn
                                  color="primary"
                                  text
                                  @click="submitOwnerApproval()"
                                  :loading="ownerApprovalLoading"
                                  :disabled="isValidUntilDateValid"
                                  >{{ $t('OK') }}</v-btn
                                >
                              </v-card-actions>
                            </v-card>
                          </v-dialog>
                          <!-- // /resume approval inside of validUntil_Expired -->
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </template>
                  <!-- // /validUntil_expired -->

                  <!-- normal approval -->
                  <template v-else>
                    <v-dialog v-model="ownerApprovalConfirmationDialog" persistent max-width="600px">
                      <template v-slot:activator="{ props: activatorProps }">
                        <v-btn class="card-button" @click="setTempStartDate(); isStartDateValid();" :disabled="!ownerApprovalReasonValid" color="primary" text v-bind="activatorProps">{{ $t('Approve') }}</v-btn>
                      </template>
                      <v-card>
                        <v-toolbar color="warning" dense>
                          <v-spacer></v-spacer>
                          <v-icon class="me-3" color="black">mdi-bell-alert</v-icon>
                        </v-toolbar>


                        <v-card-text class="text-h6 font-weight-bold">{{ $t('Approval_Confirmation') }} </v-card-text>
                        <v-card-text>
                          <v-container>
                            <v-row>
                              <v-col cols="12">
                                <template v-if="moc.changeType.type.key === 'permanent'">
                                  <div
                                    class="text-body-1"
                                    v-html="
                                      $t('Owner_Approval_Confirmation_Permanent', {
                                        coordinator: moc.roles.coordinator.displayName,
                                        startDate: formattedTempStartDate(),
                                        startDatePlus365: formattedTempStartDateBasedOnCommunitySetting()
                                      })
                                    "
                                  />
                                </template>
                                <template v-if="moc.changeType.type.key === 'temporary'">
                                  <template v-if="isMakePermanent">
                                    {{
                                      $t('Owner_Approval_Confirmation_Temporary_Make_Permanent', {
                                        coordinator: moc.roles.coordinator.displayName
                                      })
                                    }}
                                  </template>
                                  <template v-else-if="isExtend">
                                    {{
                                      $t('Owner_Approval_Confirmation_Temporary_Extend', {
                                        validUntilDate: formattedValidUntilDate()
                                      })
                                    }}
                                  </template>
                                  <template v-else>
                                    <div
                                      class="text-body-1"
                                      v-html="
                                        $t('Owner_Approval_Confirmation_Temporary', {
                                          coordinator: moc.roles.coordinator.displayName,
                                          startDate: formattedTempStartDate(),
                                          validUntilDate: formattedValidUntilDate()
                                        })
                                      "
                                    />
                                  </template>
                                </template>
                              </v-col>
                            </v-row>
                          </v-container>
                        </v-card-text>
                        <v-card-actions>
                          <v-spacer></v-spacer>
                          <!-- whoa, what another inner-inner dialog, this is just crazy stuff here this dialog is for the non-flagged path -->
                          <template v-if="!isMakePermanent && !isExtend">
                            <v-btn
                              text
                              class="card-button"
                              @click="
                                revertValidUntilDate();
                                ownerApprovalConfirmationDialog = false;
                                ownerApprovalDialog = false;                                
                                resetApprovedStartDate();                                
                              "
                              >{{ $t('Cancel') }}</v-btn
                            >
                            <v-dialog v-model="ownerApprovalNotOkDialog" persistent max-width="600px">
                              <template v-slot:activator="{ props: activatorProps }">
                                <v-btn class="card-button" text v-bind="activatorProps" @click="temporarilySetApprovedStartDate()">{{ $t('Change') }}</v-btn>
                              </template>
                              <v-card>
                                <v-toolbar color="warning" dense>
                                  <v-spacer></v-spacer>
                                  <v-icon class="me-3" color="black">mdi-bell-alert-outline</v-icon>
                                </v-toolbar>
                                <template v-if="moc.changeType.type.key === 'temporary'">
                                  <v-card-title class="text-h6 font-weight-bold">{{
                                    $t('Change_Start_Date_Coordinator_Valid_Until_Temp')
                                  }}</v-card-title>
                                </template>
                                <template v-else>
                                  <v-card-text class="text-h6 font-weight-bold">{{
                                    $t('Change_Start_Date_Coordinator')
                                  }}</v-card-text>
                                </template>
                                <v-card-text>
                                  <v-container>
                                    <template v-if="moc.changeType.type.key === 'permanent'">
                                      <v-row>
                                        <v-col cols="12">
                                          <approved-start-date-field
                                            v-model="moc.dates.approvedStart"
                                            :model-value="startDate"
                                            :roles="roles"
                                            :moc="moc"
                                            :fromModal="true"
                                            v-on:update:model-value="updateStartDate($event)"
                                          ></approved-start-date-field>
                                        </v-col>
                                      </v-row>
                                    </template>
                                    <!-- if temporary -->
                                    <template v-if="moc.changeType.type.key === 'temporary'">
                                      <v-row>
                                        <v-col cols="12">
                                          <v-menu
                                            v-model="formSettings.approvedStartDateMenu1"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="290px"
                                          >
                                            <template v-slot:activator="{ props }">
                                              <v-text-field
                                                :model-value="$filters.DateFilter(moc.dates.approvedStart)"
                                                :label="$t('Owner_Approved_Start_Date')"
                                                prepend-icon="mdi-calendar-outline"
                                                readonly
                                                variant="underlined"
                                                v-bind="props"
                                                name="approvedStartDate"
                                                :error-messages="approvedStartErrorMessage"
                                              ></v-text-field>
                                            </template>                                            
                                            <v-date-picker
                                              :model-value="getDateObject(moc.dates.approvedStart)"                                              
                                              no-title
                                              hide-header
                                              :min="minTempApprovedStartDate"
                                              :max="maxTempApprovedStartDate"
                                              :readonly="readonly"
                                              v-on:update:model-value="formSettings.approvedStartDateMenu1 = false; updateStartDateValue($event)"
                                            ></v-date-picker>
                                          </v-menu>
                                        </v-col>
                                      </v-row>
                                      <v-row>
                                        <v-col cols="12">
                                          <v-menu
                                            v-model="formSettings.validUntilDateMenu"
                                            :close-on-content-click="false"
                                            :nudge-right="40"
                                            transition="scale-transition"
                                            offset-y
                                            min-width="290px"
                                          >
                                            <template v-slot:activator="{ props }">
                                              <v-text-field
                                                :model-value="$filters.DateFilter(moc.dates.validUntil)"
                                                :label="$t('Valid_Until_Date')"
                                                prepend-icon="mdi-calendar-outline"
                                                readonly
                                                variant="underlined"
                                                v-bind="props"
                                                name="validUntilDate"
                                                :error-messages="validUntilErrorMessage"
                                              ></v-text-field>
                                            </template>
                                            <v-date-picker
                                              :model-value="getDateObject(moc.dates.validUntil)"
                                              hide-header
                                              no-title
                                              :min="minTempValidUntilDate"
                                              :max="maxTempValidUntilDate"
                                              :readonly="readonly"
                                              v-on:update:model-value="formSettings.validUntilDateMenu = false; updateValue($event)"
                                            ></v-date-picker>
                                          </v-menu>
                                        </v-col>
                                      </v-row>
                                    </template>
                                    <v-row>
                                      <v-col cols="12">
                                        <people-picker
                                          v-model="moc.roles.coordinator"
                                          :user="moc.roles.coordinator"
                                          :label="$t('Select_Coordinator')"
                                          :readonly="readonly"
                                        ></people-picker>
                                      </v-col>
                                    </v-row>
                                  </v-container>
                                </v-card-text>
                                <v-card-actions>
                                  <v-spacer></v-spacer>
                                  <v-btn
                                    text
                                    class="card-button"
                                    @click="
                                      tempStartDate = holdTempStartDate;
                                      moc.dates.approvedStart = tempStartDate;
                                      ownerApprovalNotOkDialog = false;
                                      revertValidUntilDate()
                                      setTempStartDate();
                                      isStartDateValid();
                                    "
                                  >
                                    {{ $t('Cancel') }}
                                  </v-btn>
                                  <v-btn class="card-button" color="primary" text @click="validateDates()">{{ $t('OK') }}</v-btn>
                                </v-card-actions>
                              </v-card>
                            </v-dialog>
                            <v-btn class="card-button" color="primary" text @click="submitOwnerApproval()" :loading="ownerApprovalLoading">
                              {{ $t('OK') }}
                            </v-btn>
                          </template>
                          <!-- /crazy stuff -->
                          <!-- this is the inner prompt if flag makepermanent or extend -->
                          <template v-if="isMakePermanent || isExtend">
                            <v-btn text @click="ownerApprovalDialog = false" :loading="ownerApprovalLoading">
                              {{ $t('Cancel') }}
                            </v-btn>

                            <v-btn color="primary" text @click="submitOwnerApproval()" :loading="ownerApprovalLoading">
                              {{ $t('OK') }}
                            </v-btn>
                          </template>
                          <!-- /this is the inner prompt if flag makepermanent or extend -->
                        </v-card-actions>
                      </v-card>
                    </v-dialog>
                  </template>
                  <!-- // /normal approval -->
                  <!-- /inner dialog -->
                </v-card-actions>
              </v-card>
            </v-dialog>
          </template>
          <!-- /approve -->
          <!-- additional approvers -->
          <v-dialog v-model="ownerApproverDialog" persistent max-width="600px">
            <template v-slot:activator="{ props: activatorProps }">
              <v-btn dark v-bind="activatorProps" color="blue" class="ma-2">{{ $t('Input_Required_From_Additional_Approvers') }}</v-btn>
            </template>
            <v-card>
              <v-toolbar color="warning" dense><v-spacer></v-spacer><v-icon class="me-3" color="black">mdi-bell-alert-outline</v-icon></v-toolbar>
              <v-card-text class="text-h6 font-weight-bold">{{ $t('Select_Additional_Approvers') }}</v-card-text>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-form ref="ownerApproverMo" autocomplete="off">
                        <people-picker-ms
                          :label="$t('Additional_Approvers')"
                          v-model="moc.roles.additionalApprovers"
                          :title="$t('Additional_Approvers')"
                          @update="args => this.handleUpdateAdditionalApprovers(args)"
                          bulkUserAdd
                        ></people-picker-ms>
                      </v-form>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="card-button" text @click="ownerApproverDialog = false">{{ $t('Cancel') }}</v-btn>
                <v-btn class="card-button" color="primary" text @click="submit('A')">{{ $t('OK') }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <!-- additional fyis -->
          <v-dialog v-model="ownerFyiDialog" persistent max-width="600px">
            <template v-slot:activator="{ props: activatorProps }">
              <v-btn dark v-bind="activatorProps" color="blue" class="ma-2">{{ $t('Add_Fyis') }}</v-btn>
            </template>
            <v-card>
              <v-toolbar color="warning" dense><v-spacer></v-spacer><v-icon class="me-3" color="black">mdi-bell-alert-outline</v-icon></v-toolbar>
              <v-card-text class="text-h6 font-weight-bold">{{ $t('Select_Additional_Fyis') }}</v-card-text>
              <v-card-text>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-form ref="ownerFyiMo" autocomplete="off">
                        <people-picker-ms
                          :label="$t('Additional_Fyis')"
                          v-model="moc.roles.additionalFyis"
                          :title="$t('Additional_Fyis')"
                          @update="args => this.handleUpdateAdditionalFyis(args)"
                          bulkUserAdd
                        ></people-picker-ms>
                      </v-form>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="card-button" text @click="ownerFyiDialog = false">{{ $t('Cancel') }}</v-btn>
                <v-btn class="card-button" color="primary" text @click="submit('F')">{{ $t('OK') }}</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-btn
            @click="sendReminders()"
            :disabled="!enableReminderButton || totalNoResponseApprovals === 0"
            color="blue"
            class="ma-2 white--text"
          >
            {{ $t('Remind_Non_Responders') }}
          </v-btn>
        </template>

        <!-- being implemented / change is fully in place with some open actions -->
        <template
          v-if="
            isAvailableToImplement ||
              ((isChangeInPlaceWithConsequentialActionsRequired || isTemporaryChangeInPlaceWithConsequentialActionsRequired) &&
                !readonly)
          "
        >
          <v-container fluid>
            <v-row v-if="!isOwnerEditableMakePermanent">
              <v-col cols="12" sm="6">
                <people-picker
                  :label="$t('Coordinator')"
                  :user="coordinator"
                  :inUser="coordinator"
                  name="coordinator"
                  :rules="coordinatorRules"
                  v-on:clear="moc.roles.coordinator = {}"
                  v-on:update:model-value="updateCoordinator($event)"
                  :readonly="coordinatorFieldReadOnly"
                ></people-picker>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" class="px-0">
                <template v-if="!readonly">
                  <void
                    v-if="(isAvailableToImplement && !isOwnerEditableMakePermanent) || (isBeingRevised && !readonly)"
                    :moc="moc"
                    role="owner"
                  ></void>
                  <v-btn
                    :color="isOwnerEditableMakePermanent ? 'accent' : 'success'"
                    @click="save()"
                    class="ml-2 mr-1 mb-0"
                    :disabled="!isCoordinatorValid"
                    :loading="saveLoading"
                    ><span style="color: white !important;">{{ $t('Save') }}</span></v-btn
                  >

                  <template v-if="isOwnerEditableMakePermanent">
                    <v-btn color="success" @click="submitMakePermanentAdvance()" class="mx-2 my-2">{{ $t('Submit') }}</v-btn>
                  </template>
                </template>

                <template v-if="canMakeRevision && isAvailableToImplement && !isOwnerEditableMakePermanent && !readonly">
                  <v-dialog v-model="revisionReasonDialog" persistent max-width="600px">
                    <template v-slot:activator="{ props: activatorProps }">
                      <v-btn dark v-bind="activatorProps" color="accent" class="ma-2"> <span style="color: white !important;">{{ $t('Make_Revisions') }}</span></v-btn>
                    </template>
                    <v-card>
                      <v-toolbar color="warning" dense><v-spacer></v-spacer><v-icon class="me-3" color="black">mdi-bell-alert-outline</v-icon></v-toolbar>
                      <v-card-text class="text-h6 font-weight-bold">{{ $t('Revision_Reason') }} </v-card-text>
                      <v-card-text>
                        <v-container>
                          <v-row>
                            <v-col cols="12">
                              <v-form ref="revisionReasonMo" v-model="revisionReasonValid" autocomplete="off">
                                <v-textarea
                                  v-model="revisionReason"
                                  name="revisionReason"
                                  variant="underlined"
                                  :rules="revisionReasonRules"
                                  auto-grow
                                ></v-textarea>
                              </v-form>
                            </v-col>
                          </v-row>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn class="card-button" color="primary" text @click="revisionReasonDialog = false">{{ $t('Cancel') }}</v-btn>
                        <v-btn class="card-button" color="primary" text @click="makeRevisions()">{{ $t('Save_Revise') }}</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </template>

                <template
                  v-if="
                    (isAvailableToImplement && !isOwnerEditableMakePermanent) ||
                      (isBeingRevised && !readonly) ||
                      (canMakeRevision && isAvailableToImplement && !isOwnerEditableMakePermanent && !readonly) ||
                      (isTempChangeInPlaceWithConsequentialActionsRequired && !readonly && !isOwnerEditableMakePermanent)
                  "
                >
                  <v-btn @click="tempActionDisplay = !tempActionDisplay" v-show="displayTempActions" class="mx-1 mb-2 mt-2">{{
                    $t('Owner_Temporary_Actions')
                  }}</v-btn>
                </template>
              </v-col>
            </v-row>
          </v-container>
        </template>

        <template v-if="isOwnerApprovedDeferredStartDate && !readonly">
          <v-container fluid>
            <template v-if="moc.changeType.type.key === 'permanent'">
              <v-row>
                <v-col cols="12" md="4" lg="4">
                  <approved-start-date-field
                    v-model="moc.dates.approvedStart"
                    :model-value="startDate"
                    :roles="roles"
                    :moc="moc"
                    :fromModal="true"
                    v-on:update:model-value="updateStartDate($event)"
                  ></approved-start-date-field>
                </v-col>
              </v-row>
            </template>
            <!-- if temporary -->
            <template v-if="moc.changeType.type.key === 'temporary'">
              <v-row>
                <v-col cols="12" md="4" lg="4">
                  <v-menu
                    v-model="formSettings.approvedStartDateMenu2"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ props }">
                      <v-text-field
                        :model-value="$filters.DateFilter(moc.dates.approvedStart)"
                        :label="$t('Owner_Approved_Start_Date')"
                        prepend-icon="mdi-calendar-outline"
                        readonly
                        variant="underlined"
                        v-bind="props"
                        name="approvedStartDate"
                        :error-messages="approvedStartErrorMessage"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      :model-value="getDateObject(moc.dates.approvedStart)"                      
                      no-title
                      hide-header
                      :min="minTempApprovedStartDate"
                      :max="maxTempApprovedStartDate"
                      :readonly="readonly"
                      v-on:update:model-value="formSettings.approvedStartDateMenu2 = false; updateStartDateValue($event)"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>
            </template>
            <v-row>
              <v-col cols="12">
                <v-btn @click="save()" color="success" :loading="saveLoading">{{ $t('Save') }}</v-btn>
              </v-col>
            </v-row>
          </v-container>
        </template>

        <template v-if="isSubmittedMultipass">
          <v-container fluid>
            <v-row>
              <v-col cols="12">
                <v-btn @click="save()" color="success" :loading="saveLoading">{{ $t('Save') }}</v-btn>
              </v-col>
            </v-row>
          </v-container>
        </template>

        <template v-if="isAvailableForDecision && (isMakePermanent || isExtend)">
          <!-- owner reject -->
          <v-dialog v-model="ownerRejectDialog" persistent max-width="600px">
            <template v-slot:activator="{ props: activatorProps }">
              <v-btn dark v-bind="activatorProps" color="error" class="ma-2">{{ $t('Reject') }}</v-btn>
            </template>
            <v-card>
              <v-toolbar color="warning" dense><v-spacer></v-spacer><v-icon class="me-3" color="black">mdi-bell-alert-outline</v-icon></v-toolbar>
              <v-card-text class="text-h6 font-weight-bold">{{ $t('Notification_RejectChange') }}</v-card-text>
              <v-card-text>
                <v-row>
                  <v-col cols="12">
                    <v-form ref="ownerRejectMo" v-model="ownerRejectReasonValid" autocomplete="off">
                      <v-textarea
                        :label="$t('Prompt_RejectComments')"
                        v-model="ownerRejectReason"
                        name="ownerRejectReason"
                        variant="underlined"
                        :rules="ownerRejectReasonRules"
                        auto-grow
                      ></v-textarea>
                    </v-form>
                  </v-col>
                </v-row>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="card-button" color="error" text @click="ownerRejectDialog = false">{{ $t('Cancel') }}</v-btn>
                <!-- inner dialog -->
                <v-dialog v-model="ownerRejectConfirmationDialog" persistent max-width="600px">
                  <template v-slot:activator="{ props: activatorProps }">
                    <v-btn class="card-button" :disabled="!ownerRejectReasonValid" color="primary" text v-bind="activatorProps">{{ $t('Reject') }}</v-btn>
                  </template>
                  <v-card>
                    <v-toolbar color="warning" dense><v-spacer></v-spacer><v-icon class="me-3" color="black">mdi-bell-alert-outline</v-icon></v-toolbar>
                    <v-card-text class="text-h6 font-weight-bold">{{ $t('Reject_Confirmation') }}</v-card-text>
                    <v-card-text>
                      <v-container>
                        <v-row>
                          <v-col cols="12">
                            {{ $t('Notification_RejectedChange') }}
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card-text>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn class="card-button" color="error" text @click="ownerRejectDialog = false">{{ $t('Cancel') }}</v-btn>
                      <v-btn class="card-button" color="primary" text @click="submitOwnerReject()">{{ $t('OK') }}</v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <!-- /inner dialog -->
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!-- /owner reject -->
          <v-btn @click="tempActionDisplay = !tempActionDisplay" v-show="displayTempActions" class="mx-1 mb-2 mt-2">{{
            $t('Owner_Temporary_Actions')
          }}</v-btn>
        </template>

        <template v-if="tempActionDisplay">
          <owner-temporary-actions-dialog
            :tasks="tasks"
            :moc="moc"
            :important="false"
            @close="tempActionDisplay = false"
          ></owner-temporary-actions-dialog>
        </template>

        <closer-actions :moc="moc" role="owner"></closer-actions>
      </v-form>
    </v-card>

    <toaster ref="toaster"></toaster>
    <loading-dialog ref="loadingDialog"></loading-dialog>
  </div>
</template>

<script>
import { FormStatus, Roles } from '@/common'
import { mapState } from 'vuex'
import MOCService from '@/services/moc.service'
import PeoplePicker from '@/components/peoplePicker/PeoplePicker'
import PeoplePickerMs from '@/components/peoplePicker/PeoplePickerMs'
import ApprovedStartDateField from './ApprovedStartDateField'
import { AdvanceType } from '@/common/systemTypes'
import CloserActions from '@/components/mocForm/CloserActions'
import Void from '@/components/mocForm/Void'
import Toaster from '@/components/Toaster'
import LoadingDialog from '@/components/mocForm/LoadingDialog'
import { Flags } from '@/common/flags'
import { ChangeTypes, DecisionTypes } from '@/common/types'
import dateMixins from '@/mixins/dateMixins'
import validateMoveToPendingOwnerDecisionMixin from '@/mixins/validateMoveToPendingOwnerDecisionMixin'
import OwnerTemporaryActionsDialog from '@/components/mocForm/OwnerTemporaryActionsDialog'
import moment from 'moment'
export default {
  name: 'OwnerActions',
  mixins: [dateMixins, validateMoveToPendingOwnerDecisionMixin],
  data() {
    let self = this
    return {
      isSaving: false,
      valid: false,
      validOn: false,
      formSettings: {
        approvedStartDateMenu: false,
        approvedStartDateMenu1: false,
        approvedStartDateMenu2: false,
        validUntilDateMenu: false,
        validUntilDateMenu1: false,
        validUntilDateMenu2: false,
        minStartDate: new Date(new Date().setDate(new Date().getDate() + 1)).toISOString(),
        toast: {
          snackbar: false,
          color: '',
          mode: '',
          successTimeout: 2000,
          timeout: 4000,
          text: '',
          icon: null,
          closeIcon: 'close'
        }
      },
      rules: {
        validUntilDateRules: [
          v => !!v || this.$t('Rule_Required_ValidUntilDate'),
          v => (v && self.dateEqualOrIsBefore(v, new Date(new Date().toDateString()))) || this.$t('Date_Not_In_Past')
        ]
      },
      ownerApprovalLoading: false,
      revisionReasonDialog: false,
      revisionReason: '',
      revisionReasonValid: false,
      ownerRejectDialog: false,
      ownerRejectReason: '',
      ownerRejectReasonValid: false,
      ownerRejectConfirmationDialog: false,
      ownerRevisionDialog: false,
      ownerRevisionReason: '',
      ownerRevisionReasonValid: false,
      ownerRevisionConfirmationDialog: false,
      ownerApprovalDialog: false,
      ownerApprovalReason: '',
      ownerApprovalReasonValid: false,
      ownerApprovalConfirmationDialog: false,
      ownerApprovalFlaggedNotOkDialog: false,
      ownerApprovalNotOkDialog: false,
      ownerApprovalMultipassDialog: false,
      ownerApproverDialog: false,
      ownerFyiDialog: false,
      ownerClosedDialog: false,
      returnToOriginalDialog: false,
      returnToOriginalSecondConfirmationDialog: false,
      tempStartDate: '',
      allApprovals: [],
      closeDialog: false,
      closerDeniedReason: '',
      notReadyToCloseDialog: false,
      enableReminderButton: false,
      saveLoading: false,
      ownerApprovalValidUntilValid: false,
      ownerApprovalValidUntilExpiredDialog: false,
      holdValidUntilDate: null,
      holdTempStartDate: null,
      tempActionDisplay: false,
      validUntilErrorMessage: '',
      approvedStartErrorMessage: ''
    }
  },
  props: {
    roles: {
      type: Array,
      default: null
    },
    moc: {
      type: Object
    },
    tempAdditionalApprovers: {
      type: Array
    },
    tempAdditionalFyis: {
      type: Array
    },
    areTasksCompleted: {
      type: Boolean
    },
    tasks: {
      type: Array
    },
    showTempActions: {
      type: Boolean
    }
  },
  components: {
    PeoplePicker,
    PeoplePickerMs,
    ApprovedStartDateField,
    CloserActions,
    Void,
    Toaster,
    LoadingDialog,
    OwnerTemporaryActionsDialog
  },
  methods: {
    temporarilySetApprovedStartDate() {
      console.log(`owner action approve moment().format() ${moment().format()}`)
      this.moc.dates.approvedStart = this.moc.dates.approvedStart
        ? this.moc.dates.approvedStart
        : this.moc.dates.start
        ? this.moc.dates.start
        : moment().format()
    },
    resetApprovedStartDate() {
      this.moc.dates.approvedStart = null
    },
    dateEqualOrIsAfter(fromDate, toDate) {
      return this.moc.changeType.type.key === ChangeTypes.TEMPORARY.toString() && new Date(fromDate) <= new Date(toDate)
    },
    dateEqualOrIsBefore(fromDate, toDate) {
      return this.moc.changeType.type.key === ChangeTypes.TEMPORARY.toString() && new Date(fromDate) >= new Date(toDate)
    },
    handleUpdateAdditionalApprovers: function(usersAction) {
      this.moc.roles.additionalApprovers = usersAction.Users
    },
    handleUpdateAdditionalFyis: function(usersAction) {
      this.moc.roles.additionalFyis = usersAction.Users
    },
    handleOwnerTemporaryActionsClose: function() {
      this.tempActionDisplay = false
    },
    isStartDateValid: function() {
      if (moment(this.tempStartDate).isBefore(moment.now())) {
        // last minute enhancement says that if the start date is in the past, set it to today
        this.tempStartDate = moment().format()
      }
    },
    sendReminders: function() {
      this.$refs.loadingDialog.show()
      MOCService.remindNonRespondersApprovers(this.moc.mocId)
        .then(() => {
          this.enableReminderButton = false
          this.$refs.loadingDialog.hide({ redirect: true, message: this.$t('Success_ReminderSent') })
        })
        .catch(e => {
          this.$refs.loadingDialog.error({
            metadata: 'sendReminders',
            error: e,
            message: e.response.data ? this.$t('Error_SendNotification') : e.response.data.message
          })
        })
    },
    revertValidUntilDate: function() {
      this.moc.dates.validUntil = this.holdValidUntilDate
    },
    save: function() {
      this.saveLoading = true
      const data = this.moc

      this.$refs.loadingDialog.show()
      MOCService.save(data, AdvanceType.NONE)
        .then(async result => {
          if (result.success) {
            this.$refs.loadingDialog.hide({ redirect: true })
          } else {
            throw new Error(result.message)
          }
        })
        .catch(e => {
          this.$refs.loadingDialog.error({
            metadata: 'save',
            error: e
          })
        })
        .finally(() => {
          this.saveLoading = false
        })
    },
    setTempStartDate: function() {
      this.tempStartDate = this.moc.dates.approvedStart
        ? this.moc.dates.approvedStart
        : this.moc.dates.start
        ? this.moc.dates.start
        : moment().format()
    },
    submit: function(role) {
      const data = this.moc
      this.$refs.loadingDialog.show()
      MOCService.save(data, AdvanceType.NONE)
        .then(result => {
          if (!result.success) {
            throw new Error(result.message)
          }
          if (role === 'A') {
            this.$refs.loadingDialog.hide({ redirect: true, message: this.$t('Success_AdditionalApproverAdded') })
          }
          if (role === 'F') {
            this.$refs.loadingDialog.hide({ redirect: true, message: this.$t('Success_AdditionalFyiAdded') })
          }
        })
        .catch(e => {
          this.$refs.loadingDialog.error({
            metadata: role === 'A' ? 'submit: additional Approvers' : 'submit: additional Fyis',
            error: e,
            message: role === 'A' ? this.$t('Error_AddAdditionalApprovers') : this.$t('Error_AddAdditionalFyis')
          })
        })
    },
    submitMakePermanentAdvance: function() {
      const data = this.moc
      this.$refs.loadingDialog.show()
      MOCService.save(data, AdvanceType.ADVANCE)
        .then(result => {
          if (result.success) {
            this.$refs.loadingDialog.hide({ redirect: true })
          } else {
            throw new Error(result.message)
          }
        })
        .catch(e => {
          this.$refs.loadingDialog.error({
            metadata: 'submitMakePermanentAdvance',
            error: e
          })
        })
    },
    submitOwnerApproval: function() {
      if (!this.isSaving) {
        this.isSaving = true
        if (!this.moc.ownerDecision) {
          this.moc.ownerDecision = {}
        }
        this.moc.ownerDecision.decision = { key: 'approved', value: 'Approved' }
        this.moc.ownerDecision.reason = this.ownerApprovalReason ? this.ownerApprovalReason : this.$t('No_Comment')

        if (this.moc.multiPassCurrentPass >= this.moc.approvalProcessType.decisionPasses) {
          this.moc.dates.approvedStart = this.tempStartDate
        }

        const data = this.moc
        this.$refs.loadingDialog.show()
        MOCService.save(data, AdvanceType.ADVANCE)
          .then(result => {
            if (!result.success) {
              throw new Error(result.message)
            }
            this.$refs.loadingDialog.hide({ redirect: true, message: this.$t('Success_OwnerApprovalSaved') })
          })
          .catch(e => {
            this.$refs.loadingDialog.error({
              metadata: 'submitOwnerApproval',
              error: e
            })
          })
          .finally(() => {
            this.isSaving = false
          })
      }
    },
    submitOwnerFormChanges: function() {
      if (!this.isSaving) {
        this.isSaving = true
        const data = this.moc
        this.$refs.loadingDialog.show()
        MOCService.save(data, AdvanceType.ADVANCE)
          .then(result => {
            if (!result.success) {
              throw new Error(result.message)
            }
            this.$refs.loadingDialog.hide({ redirect: true, message: this.$t('Success_OwnerFormChanges') })
          })
          .catch(e => {
            this.$refs.loadingDialog.error({
              metadata: 'submitOwnerFormChanges',
              error: e
            })
          })
          .finally(() => {
            this.isSaving = false
          })
      }
    },
    saveOwnerFormChanges: async function() {
      if (!this.isSaving) {
        this.isSaving = true

        this.$refs.loadingDialog.show()
        const data = this.moc
        MOCService.save(data, AdvanceType.NONE)
          .then(result => {
            if (!result.success) {
              throw new Error(result.message)
            }
            this.$refs.loadingDialog.hide({ redirect: true, message: this.$t('Success_OwnerFormChanges') })
          })
          .catch(e => {
            this.$refs.loadingDialog.error({
              metadata: 'saveOwnerFormChanges',
              error: e
            })
          })
          .finally(() => {
            this.isSaving = false
          })
      }
    },
    getDateObject(date){
      if(date){
        return new Date(date)
      }
      else{
        return null
      }
    },
    submitOwnerReject: function() {
      if (!this.isSaving) {
        this.isSaving = true
        if (this.$refs.ownerRejectMo.validate()) {
          if (!this.moc.ownerDecision) {
            this.moc.ownerDecision = {}
          }
          this.moc.ownerDecision.decision = { key: 'rejected', value: 'Rejected' }
          this.moc.ownerDecision.reason = this.ownerRejectReason
          const data = this.moc
          this.$refs.loadingDialog.show()
          MOCService.save(data, AdvanceType.CLOSE)
            .then(result => {
              if (!result.success) {
                throw new Error(result.message)
              }
              this.$refs.loadingDialog.hide({ redirect: true, message: this.$t('Success_OwnerRejectSaved') })
            })
            .catch(e => {
              this.$refs.loadingDialog.error({
                metadata: 'submitOwnerReject',
                error: e,
                message: this.$t('Error_OwnerReject')
              })
            })
            .finally(() => {
              this.isSaving = false
            })
        }
      }
    },
    async makeRevisions() {
      let allGood = false

      if (this.$refs.revisionReasonMo) {
        const result = await this.$refs.revisionReasonMo.validate();
        if (result.valid) {
          allGood = true
        }
      } else {
        allGood = true
      }
      if (allGood) {
        this.moc.revisionReason = { reason: this.revisionReason }
        const data = this.moc
        this.$refs.loadingDialog.show()
        MOCService.save(data, AdvanceType.REVISION)
          .then(result => {
            if (!result.success) {
              throw new Error(result.message)
            }
            this.$refs.loadingDialog.hide({ redirect: true, message: this.$t('Success_MakeRevisionsSaved') })
          })
          .catch(e => {
            this.$refs.loadingDialog.error({
              metadata: 'makeRevisions',
              error: e,
              message: this.$t('Error_MakeRevisions')
            })
          })
      }
    },
    updateCoordinator: function(value) {
      this.$emit('selectedCoordinator', value)
    },
    updateStartDate: function(v) {
      this.tempStartDate = v
    },
    updateValue: function(value) {
      this.validUntilErrorMessage = ''
      let now = moment()
      let time = now.hour() + ':' + now.minute() + ':' + now.second()
      let dateString = value.getFullYear() + '-' + this.getTimeLeftPad(value.getMonth() + 1)  + '-' + this.getTimeLeftPad(value.getDate())
      let newDateTime = dateString + ' ' + time
      this.moc.dates.validUntil = moment(newDateTime).format()
    },
    getTimeLeftPad: function(number){
      if(number.length < 2){
        return '0' + number
      }
      return number
    },
    updateStartDateValue: function(value) {
      this.approvedStartErrorMessage = ''
      let now = moment()
      let time = now.hour() + ':' + now.minute() + ':' + now.second()
      let dateString = value.getFullYear() + '-' + this.getTimeLeftPad(value.getMonth() + 1)  + '-' + this.getTimeLeftPad(value.getDate())
      let newDateTime = dateString + ' ' + time
      this.moc.dates.approvedStart = moment(newDateTime).format()
    },
    validateDates: function() {
      if (this.moc.changeType.type.key === 'temporary') {
        let startDate = this.moc.dates.approvedStart
          ? this.moc.dates.approvedStart
          : this.moc.dates.start
          ? this.moc.dates.start
          : moment().format()

        this.tempStartDate = startDate
        // if the start date is in the past from today we cannot use that, so set it to today
        if (moment(startDate).isBefore(moment())) {
          startDate = moment()
        }

        if (moment(startDate).isSameOrAfter(this.moc.dates.validUntil)) {
          // boom
          this.validUntilErrorMessage = this.$t('Valid_Until_Must_Come_After_Start')
          return
        }
      }

      // no change of plans, no submit, we are cool, hide the pop up
      this.ownerApprovalNotOkDialog = false
    },
    formattedTempStartDate() {
      // this.setTempStartDate()
      // this.isStartDateValid()
      return moment(this.tempStartDate).format('LL')
    },
    formattedTempStartDateBasedOnCommunitySetting() {
      const startDate = new Date(this.tempStartDate)
      const dueDate = moment(startDate)
        .add(this.moc.communityData.durationInDays || 365, 'd')
        .format('LL')
      return dueDate
    },
    formattedValidUntilDate() {
      return moment(this.moc.dates.validUntil).format('LL')
    },    
  },
  computed: {
    ...mapState('currentUser', ['user']),
    backgroundColor() {
      return this.readonly ? 'backgroundReadOnly' : 'backgroundEditable'
    },
    coordinatorFieldReadOnly() {
      return (this.moc.flags || []).includes('unauthorized') ? true : this.readonly
    },
    displayTempActions() {
      return this.showTempActions && !this.moc.flags.includes(Flags.properties[Flags.RETURNTOORIGINALCONDITION].key)
    },
    minTempApprovedStartDate() {
      return moment().startOf('day').format()
    },
    maxTempApprovedStartDate() {
      let temp = this.moc.dates.validUntil ? this.moc.dates.validUntil : this.maxDateComputed365
      return temp
    },
    minTempValidUntilDate() {
      let temp = this.moc.dates.approvedStart ? this.moc.dates.approvedStart : this.moc.dates.start
      if (moment(temp).isBefore(moment())) {
        temp = moment()
      }

      return moment(temp).startOf('day').format()
    },
    maxTempValidUntilDate() {
      let temp = this.moc.dates.approvedStart ? this.moc.dates.approvedStart : this.moc.dates.start
      return moment(temp)
        .add(180, 'd')
        .format()
    },
    readonly: function() {
      switch (this.moc.status.value) {
        case FormStatus.properties[FormStatus.SUBMITTED].value: {
          if (
            (this.moc.flags || []).includes(Flags.properties[Flags.MULTIPASS].key) &&
            this.roles.includes(Roles.properties[Roles.OWNER].value)
          ) {
            return false
          }
          return true
        }
        case FormStatus.properties[FormStatus.AVAILABLETOIMPLEMENT].value: {
          if (this.roles.includes(Roles.properties[Roles.OWNER].value)) {
            return false
          }
          return true
        }
        case FormStatus.properties[FormStatus.PENDINGOWNERDECISION].value:
        case FormStatus.properties[FormStatus.AVAILABLEFORDECISION].value:
        case FormStatus.properties[FormStatus.BEINGREVISED].value:
        case FormStatus.properties[FormStatus.CHANGEISFULLYIMPLEMENTED].value:
        case FormStatus.properties[FormStatus.CHANGEISINPLACEWITHCONSEQUENTIALACTIONSREQUIRED].value:
        case FormStatus.properties[FormStatus.OWNERAPPROVEDDEFERREDSTARTDATE].value:
        case FormStatus.properties[FormStatus.TEMPORARYCHANGEISINPLACEWITHCONSEQUENTIALACTIONSREQUIRED].value: {
          if (this.roles.includes(Roles.properties[Roles.OWNER].value)) {
            return false
          }
          return true
        }
        default:
          return true
      }
    },
    canApprove: function() {
      if (this.canOwnerApprove && this.areTasksCompleted) {
        return true
      }
      return false
    },
    canMakeRevision: function() {
      if (this.isMakePermanent || this.isExtend) {
        return false
      }
      return (this.moc.revisionHistory || []).length < 2
    },
    coordinator: function() {
      if (this.moc.roles.coordinator && this.moc.roles.coordinator.displayName) {
        return this.moc.roles.coordinator
      }
      return null
    },
    coordinatorRules: {
      get: function() {
        return [v => !!v || this.$t('Rule_Required_Coordinator')]
      }
    },
    // formattedTempStartDate() {
    //   this.setTempStartDate()
    //   this.isStartDateValid()
    //   return moment(this.tempStartDate).format('LL')
    // },
    // formattedTempStartDateBasedOnCommunitySetting() {
    //   const startDate = new Date(this.tempStartDate)
    //   const dueDate = moment(startDate)
    //     .add(this.moc.communityData.durationInDays || 365, 'd')
    //     .format('LL')
    //   return dueDate
    // },
    // formattedValidUntilDate() {
    //   return moment(this.moc.dates.validUntil).format('LL')
    // },
    isCoordinatorValid: function() {
      return (this.moc.roles.coordinator || {}).displayName ? true : false
    },
    ownerApproved: function() {
      return ((this.moc.ownerDecision || {}).decision || {}).key === DecisionTypes.properties[DecisionTypes.APPROVED].key
    },
    ownerRejectReasonRules: {
      get: function() {
        return [v => !!v || this.$t('Rule_Required'), v => (v && v.trim().length >= 1) || this.$t('Rule_Required')]
      }
    },
    ownerRevisionReasonRules: {
      get: function() {
        return [v => !!v || this.$t('Rule_Required'), v => (v && v.trim().length >= 1) || this.$t('Rule_Required')]
      }
    },
    revisionReasonRules: {
      get: function() {
        return [v => !!v || this.$t('Rule_Required'), v => (v && v.trim().length >= 1) || this.$t('Rule_Required')]
      }
    },
    isAvailableForDecision: function() {
      return this.moc.status.value === FormStatus.properties[FormStatus.AVAILABLEFORDECISION].value
    },
    isBeingRevised: function() {
      return this.moc.status.value === FormStatus.properties[FormStatus.BEINGREVISED].value
    },
    isAvailableToImplement: function() {
      return this.moc.status.value === FormStatus.properties[FormStatus.AVAILABLETOIMPLEMENT].value
    },
    isChangeInPlaceWithConsequentialActionsRequired: function() {
      return this.moc.status.value === FormStatus.properties[FormStatus.CHANGEISINPLACEWITHCONSEQUENTIALACTIONSREQUIRED].value
    },
    isTemporaryChangeInPlaceWithConsequentialActionsRequired: function() {
      return (
        this.moc.status.value === FormStatus.properties[FormStatus.TEMPORARYCHANGEISINPLACEWITHCONSEQUENTIALACTIONSREQUIRED].value
      )
    },
    isDateValid: function() {
      return Date.now() >= new Date(this.moc.dates.validUntil).getTime() ? true : false
    },
    isExtend: function() {
      return (this.moc.flags || []).includes(Flags.properties[Flags.EXTEND].key)
    },
    isHoldValidUntilDateValid: function() {
      return moment().isSameOrAfter(moment(this.holdValidUntilDate))
    },
    isMakePermanent: function() {
      return (this.moc.flags || []).includes(Flags.properties[Flags.MAKEPERMANENT].key)
    },
    isValidUntilDateValid: function() {
      let now = moment()

      if (now.isSame(moment(this.moc.dates.validUntil))) {
        return false
      }
      return moment(this.moc.dates.validUntil, 'YYYY-MM-DDTHH:mm:ssZ').isBefore(now, 'day')
    },
    isOwnerApprovedDeferredStartDate: function() {
      return this.moc.status.value === FormStatus.properties[FormStatus.OWNERAPPROVEDDEFERREDSTARTDATE].value
    },
    isOwnerEditableMakePermanent: function() {
      return (this.moc.flags || []).includes(Flags.properties[Flags.OWNEREDITABLEMAKEPERMANENT].key)
    },
    isPendingOwnerDecision: function() {
      return this.moc.status.value === FormStatus.properties[FormStatus.PENDINGOWNERDECISION].value
    },
    isSubmittedMultipass: function() {
      return (
        this.moc.status.value === FormStatus.properties[FormStatus.SUBMITTED].value &&
        (this.moc.flags || []).includes('multipass')
      )
    },
    isTempChangeInPlaceWithConsequentialActionsRequired: function() {
      return (
        this.moc.status.value === FormStatus.properties[FormStatus.TEMPORARYCHANGEISINPLACEWITHCONSEQUENTIALACTIONSREQUIRED].value
      )
    },
    startDate: function() {
      return this.tempStartDate
    },
    totalNoResponseApprovals() {
      return this.allApprovals.filter(a => a.decisionPass === this.moc.multiPassCurrentPass).filter(a => !a.decision.key).length
    }
  },
  created() {
    this.holdTempStartDate = this.moc.dates.approvedStart
        ? this.moc.dates.approvedStart
        : this.moc.dates.start == null ? new Date().toISOString() : this.moc.dates.start
    this.tempStartDate = this.moc.dates.approvedStart
        ? this.moc.dates.approvedStart
        : this.moc.dates.start == null ? new Date().toISOString() : this.moc.dates.start
    MOCService.isEnableReminderToNonRespondersApprovers(this.moc.mocId, this.moc.multiPassCurrentPass)
      .then(result => (this.enableReminderButton = result))
      .catch(() => (this.enableReminderButton = false))
  },
  mounted() {
    this.moc.roles.additionalApprovers = this.tempAdditionalApprovers
    this.moc.roles.additionalFyis = this.tempAdditionalFyis
    this.holdValidUntilDate = this.moc.dates.validUntil
  }
}
</script>

<style scoped></style>
